module.exports = __webpack_public_path__ + "img/life@Q_celebrate.4bbc75d4.jpg";